import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button } from 'reactstrap';
const FavoriteTitlePromptModal = ({
  isOpen,
  title,
  onTitleChange,
  onSubmit,
  onCancel,
  inputRef: _inputRef = null
}) => /*#__PURE__*/React.createElement(Modal, {
  isOpen: isOpen,
  toggle: onCancel,
  backdrop: true,
  keyboard: true,
  style: {
    maxWidth: '400px'
  }
}, /*#__PURE__*/React.createElement(ModalHeader, {
  toggle: onCancel
}, "Add Title for Favorite"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("p", {
  className: "mb-3"
}, "Enter a name for this favorite:"), /*#__PURE__*/React.createElement(Input, {
  innerRef: _inputRef,
  type: "text",
  placeholder: "Enter a title for this favorite...",
  value: title,
  onChange: e => onTitleChange(e.target.value),
  onKeyDown: e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  },
  autoFocus: true
})), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
  type: "button",
  color: "secondary",
  onClick: onCancel
}, "Cancel"), /*#__PURE__*/React.createElement(Button, {
  type: "button",
  color: "primary",
  onClick: onSubmit,
  disabled: !title.trim()
}, "Add Favorite")));
FavoriteTitlePromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onTitleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  inputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
};
export default FavoriteTitlePromptModal;